module.exports = __webpack_public_path__ + "static/img/PC-11ic-Sports@2x.4a17763.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build902/components/new-home/img/PC-11ic-Sports@2x.png
// module id = PQJh
// module chunks = 42